import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import { DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';


@Component({
    selector: 'app-issue-very-brif-representative',

    templateUrl: './issue-very-brif-representative.component.html',
    styleUrl: './issue-very-brif-representative.component.scss'
})
export class IssueVeryBrifRepresentativeComponent {
    isLoading: boolean = false;
    type: string;
    start_date: string = '';
    end_date: string = '';
    rep_name: string = '';
    off_rep_name: string = '';
    issue_cat: string = '';
    issue_date: string = '';
    newissuedatepp: any;

    newindetails = false;
    indetail = false;
    brfly = false;
    verybrfly = false;
    datewise = false;
    officerep = false;
    showbrfly = false;

    inDetailsRegReport: any;
    inDetailsRegReportTotal = {
        total_advt: 0,
        advt_total: 0,
        net_amt: 0,
        gst: 0,
        total_amt: 0,
        rcvd_amt: 0,
        pndg_amt: 0,
    };

    inDetailsOffRegReportTotal = {
        total_advt: 0,
        advt_total: 0,
        net_amt: 0,
        gst: 0,
        total_amt: 0,
        rcvd_amt: 0,
        pndg_amt: 0,
    };

    // filteredinDetailsRegReport: any;
    // totalAmounts = {
    //   total_amount: 0,
    //   net_amount: 0,
    //   without_gst_amount: 0,
    //   issue_selling_amount: 0,
    //   issue_selling_discount_amt: 0,
    //   with_gst_amount: 0,
    //   issue_seller_price: 0,
    //   gst_amount: 0,
    //   issue_seller_copies: 0
    // };

    rep_type: string;
    getdatabydep: any;
    categoryNameForHTML: any;
    issueNameForHTML: any;
    inDetailsRegReportrep: any;
    issuenamewithdate: any;
    inDetailsRegReport1: any;

    advtamt: number;
    netadvtamt: number;
    gstadvtamt: number;
    totaladvtamt: number;
    totalgst: number;
    remaingtotal: number;
    totalpendingadvtamt: number;
    jamatotal: number;

    totaldisc_total: number;
    totalbefore_gst: number;
    total_pending: number;
    show: boolean;
    total_issue_copies: number;
    total_pending_amt: number;
    inDetailsbriflydata: any;
    totalbeforegst_amt: number;
    jamatotalb: number;
    advtamtb: number;
    grand_total_discounted: number;
    grand_total_advt: number;
    grand_total_before_gst: number;
    grand_total_gst: number;
    grand_total_amt: number;
    grand_total_rcv: number;
    grand_total_pending: number;

    constructor(
        private dialogRef: MatDialogRef<IssueVeryBrifRepresentativeComponent>,
        private datePipe: DatePipe,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private service: DigisubservicesService
    ) { }

    //  newissuedatepp:any
    ngOnInit(): void {
        this.type = this.data['type'];
        this.start_date = this.data['start_date'];
        this.end_date = this.data['end_date'];
        this.rep_name = this.data['rep_name'];
        this.off_rep_name = this.data['off_rep_name'];
        this.newissuedatepp = this.data['newissuedatepp'];

        this.issue_cat = this.data['issue_cat'] === undefined ? "ALL" : this.data['issue_cat'];

        // Extract only the date part (before first comma)
        const issueDateRaw = this.data['issueDates'];
        if (Array.isArray(issueDateRaw) && issueDateRaw.length > 0) {
            this.issue_date = issueDateRaw[0].split(',')[0];
        } else {
            this.issue_date = "ALL";
        }

        console.log("Final Payload Data:", {
            representativeId: this.rep_name,
            startDate: this.start_date,
            endDate: this.end_date,
            officeRepresentativeId: this.off_rep_name,
            issueNameId: this.issue_cat,
            issueSellerDate: this.issue_date
        });

        this.getRegReportData();
    };
    filteredinDetailsRegReport: any
    showindetail: boolean = false;
    totalAmounts = {
        total_amount: 0,
        net_amount: 0,
        without_gst_amount: 0,
        issue_selling_amount: 0,
        issue_selling_discount_amt: 0,
        with_gst_amount: 0,
        issue_seller_price: 0,
        gst_amount: 0,
        issue_seller_copies: 0
    };
    getRegReportData() {
         const issuesellerbooking = {
            "representativeId": this.rep_name,
            "startDate": this.start_date,
            "endDate": this.end_date,
            "officeRepresentativeId": this.off_rep_name,
            "issueNameId": this.issue_cat,
            "issueSellerDate": this.issue_date
        }
        this.service.getRegReportverybriflyrep(issuesellerbooking).subscribe((data) => {
            debugger
            this.inDetailsRegReport = data;
            this.inDetailsRegReportrep = data;
            // this.issuenamewithdate = this.inDetailsRegReport1.issue_date;
            // console.log(this.inDetailsRegReport1,  "reg report")

            this.grand_total_advt = 0;
            this.grand_total_discounted = 0;
            this.grand_total_before_gst = 0;
            this.grand_total_gst = 0;
            this.grand_total_amt = 0;
            this.grand_total_rcv = 0;
            this.grand_total_pending = 0;

            for (let item of this.inDetailsRegReport) {
                debugger
                this.grand_total_advt += parseFloat(item.total_advt_amount) || 0;
                this.grand_total_discounted += parseFloat(item.total_discounted_amt) || 0;
                this.grand_total_before_gst += parseFloat(item.total_before_gst) || 0;
                this.grand_total_gst += parseFloat(item.total_gst) || 0;
                this.grand_total_amt += parseFloat(item.total_amt) || 0;
                this.grand_total_rcv += parseFloat(item.total_rcv) || 0;
                this.grand_total_pending += parseFloat(item.total_pending) || 0;
            }



            console.log(this.total_pending, "total_pending");
            this.addFilters();
            this.getReportDatewise();

            // this.getReportDatewise();
        });

        this.show = true;
        const printSection = document.getElementById('print-section');
        if (!printSection) {
            console.error("Print section not found!");
            return;
        }

        const printContent = printSection.innerHTML;

        const screenWidth = window.screen.availWidth;
        const windowWidth = 1500;
        const leftPosition = screenWidth - windowWidth - 50;

        const printWindow = window.open('', '', `width=${windowWidth},height=1000,top=50,left=${leftPosition},scrollbars=yes`);

        if (printWindow) {
            printWindow.document.open();
            printWindow.document.write(`
            <html>
                <head>
                    <title>Print Report</title>
                    <style>
                        @media print {
                            @page {
                                size: A3 landscape;
                                margin: 3mm;
                            }
                            body {
                                font-family: Arial, sans-serif;
                                margin: 0;
                                padding: 0;
                                font-size: 10px !important;
                                color: #000 !important; /* Ensure dark text */
                                -webkit-print-color-adjust: exact !important;
                                print-color-adjust: exact !important;
                            }
                            .print-section {
                                width: 100%;
                                margin: 0 auto;
                                padding: 0;
                            }
                            table {
                                width: 100% !important;
                                border-collapse: collapse !important;
                                border-spacing: 0 !important;
                                table-layout: auto;
                                page-break-inside: auto;
                                border: 2px solid #000 !important;
                            }
                            tr {
                                page-break-inside: avoid;
                                page-break-after: auto;
                            }
                            th, td {
                                padding: 3px 5px !important;
                                border: 1px solid #000 !important;
                                font-size: 10px !important;
                                line-height: 1.3;
                                word-wrap: break-word;
                                overflow-wrap: break-word;
                                color: #000 !important;
                            }
                            th {
                                background-color: #f2f2f2 !important;
                                font-weight: bold !important;
                                border-bottom: 2px solid #000 !important;
                            }
                            tr {
                                border-bottom: 1px solid #000 !important;
                            }
                            tr.header-row {
                                display: table-header-group !important;
                            }
                            td:nth-child(1) {
                                width: 1%;
                                text-align: left !important;
                                border-left: 1px solid #000 !important;
                            }
                            td:nth-child(2),
                            td:nth-child(3),
                            td:nth-child(4),
                            td:nth-child(5),
                            td:nth-child(6),
                            td:nth-child(8) {
                                text-align: left !important;
                            }
                            td:nth-child(5) {
                                width: 5%;
                                white-space: normal;
                            }
                            td.advt-name {
                                max-width: 160px;
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                            }
                            td:nth-child(n+12),
                            td.amount,
                            td[data-type="number"] {
                                text-align: right !important;
                            }
                            td.text,
                            td[data-type="string"] {
                                text-align: left !important;
                            }
                            .br-right { border-right: 2px solid #000 !important; }
                            .br-rightt { border-right: 4px solid #000 !important; }
                            .br-bottom { border-bottom: 2px solid #000 !important; }
                            .br-top { border-top: 2px solid #000 !important; }
                            .noPrint { display: none !important; }
                            .footer-line {
                                position: fixed;
                                bottom: 0;
                                left: 0;
                                width: 100%;
                                height: 2px;
                                background-color: #000;
                                border-top: 2px solid #000 !important;
                            }
                            thead { 
                                display: table-header-group !important; 
                                border-bottom: 2px solid #000 !important;
                            }
                            tfoot { 
                                display: table-footer-group !important; 
                                border-top: 2px solid #000 !important;
                            }
                            td.balance-value {
                                text-align: right !important;
                                font-weight: bold !important;
                            }
                            /* Force all borders to be visible and dark */
                            table *, table *:before, table *:after {
                                border-color: #000 !important;
                                border-style: solid !important;
                                border-width: 1px !important;
                            }
                            /* Make sure header repeats on each page */
                            thead tr {
                                display: table-row !important;
                            }
                            /* Ensure table headers are bold and dark */
                            th {
                                font-weight: bold !important;
                                color: #000 !important;
                            }
                            /* Force print background colors */
                            * {
                                -webkit-print-color-adjust: exact !important;
                                print-color-adjust: exact !important;
                            }
                        }
                        
                        /* Screen styles (preview) */
                        @media screen {
                            body {
                                font-family: Arial, sans-serif;
                                margin: 0;
                                padding: 20px;
                                font-size: 10px;
                                color: #000;
                            }
                            table {
                                border: 2px solid #000;
                            }
                            th, td {
                                border: 1px solid #000;
                            }
                        }
                    </style>
                </head>
                <body>
                    <div class="print-section">
                        ${printContent}
                        <div class="footer-line"></div>
                    </div>
                    <script>
                        window.onload = function() {
                            const table = document.querySelector('table');
                            if (!table) {
                                console.error("Table not found");
                                return;
                            }
                            
                            // Apply borders forcefully to all cells
                            const allCells = document.querySelectorAll('th, td');
                            allCells.forEach(cell => {
                                cell.style.border = '1px solid #000 !important';
                                cell.style.color = '#000 !important';
                            });
                            
                            // Find and process header row
                            let headerRowIndex = -1;
                            const maxRowsToCheck = Math.min(10, table.rows.length);
                            
                            for (let i = 0; i < maxRowsToCheck; i++) {
                                const row = table.rows[i];
                                const cellTexts = Array.from(row.cells).map(cell => cell.textContent.trim());
                                
                                if (row.cells.length >= 8 &&
                                    (cellTexts.includes('Invoice No') ||
                                     cellTexts.includes('Receipt No') ||
                                     cellTexts.includes('Balance'))) {
                                    headerRowIndex = i;
                                    break;
                                }
                            }
                            
                            if (headerRowIndex >= 0) {
                                let thead = table.querySelector('thead');
                                if (!thead) {
                                    thead = document.createElement('thead');
                                    table.insertBefore(thead, table.firstChild);
                                }
                                
                                const headerRow = table.rows[headerRowIndex];
                                thead.appendChild(headerRow.cloneNode(true));
                            }
                            
                            // Alignment processing
                            const cells = document.querySelectorAll('td');
                            cells.forEach(cell => {
                                const content = cell.textContent.trim();
                                
                                if (content.includes('येणे') ||
                                    content.includes('Opening Balance') ||
                                    content.match(/^\\d+\\s+येणे$/) ||
                                    content.includes('Balance C/F') ||
                                    content.includes('Total')) {
                                    cell.style.textAlign = 'right';
                                    cell.classList.add('balance-value');
                                }
                                
                                const numericPattern = /^-?\\d+(,\\d{3})*(\\.\\d+)?$/;
                                if (numericPattern.test(content.replace(/[\\s,]/g, ''))) {
                                    cell.style.textAlign = 'right';
                                    cell.classList.add('amount');
                                }
                                
                                // Force borders and dark text
                                cell.style.border = '1px solid #000 !important';
                                cell.style.color = '#000 !important';
                            });
                            
                            setTimeout(() => {
                                window.print();
                                setTimeout(() => { window.close(); }, 500);
                            }, 500); // Increased delay for better rendering
                        };
                    </script>
                </body>
            </html>
        `);
            printWindow.document.close();
        } else {
            console.error("Failed to open print window.");
        }
    }
    addFilters() {
        throw new Error('Method not implemented.');
    }
    getReportDatewise() {
        throw new Error('Method not implemented.');
    }


    exportExcel(fileName): void {
        /* table id is passed over here */
        let element = document.getElementById('excel-table');
        const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

        /* save to file */
        XLSX.writeFile(wb, fileName + '.xlsx');
    }
}
